/* Parwin product image lightbox: tap the gallery image to enlarge (all angles),
   with swipe navigation, double-tap + pinch zoom, and drag-to-pan. */
(function () {
  if (window.__pvgZoom) return; window.__pvgZoom = true;

  var CSS = ''
  + '.pvg__main-img{cursor:zoom-in}'
  + '.pvg__main{position:relative}'
  + '.pvg__zoomhint{position:absolute;right:10px;bottom:10px;z-index:3;width:34px;height:34px;border-radius:50%;'
  +   'background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;pointer-events:none}'
  + '.pvg__zoomhint svg{width:18px;height:18px;fill:none;stroke:#fff;stroke-width:2}'
  + '.pvgz{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.92);display:none;touch-action:none;'
  +   'align-items:center;justify-content:center;overscroll-behavior:contain}'
  + '.pvgz.is-open{display:flex}'
  + '.pvgz__stage{position:relative;width:100%;height:100%;overflow:hidden;display:flex;align-items:center;justify-content:center}'
  + '.pvgz__img{max-width:96vw;max-height:92vh;width:auto;height:auto;object-fit:contain;user-select:none;-webkit-user-drag:none;transform-origin:0 0;'
  +   'transition:transform .05s linear;will-change:transform}'
  + '.pvgz__btn{position:fixed;z-index:100000;background:rgba(255,255,255,.14);color:#fff;border:0;cursor:pointer;'
  +   'display:flex;align-items:center;justify-content:center;border-radius:50%;-webkit-tap-highlight-color:transparent}'
  + '.pvgz__btn:hover{background:rgba(255,255,255,.28)}'
  + '.pvgz__close{top:14px;right:14px;width:44px;height:44px;font-size:26px;line-height:1}'
  + '.pvgz__nav{top:50%;transform:translateY(-50%);width:48px;height:48px;font-size:30px;line-height:1}'
  + '.pvgz__prev{left:10px}.pvgz__next{right:10px}'
  + '.pvgz__count{position:fixed;bottom:16px;left:50%;transform:translateX(-50%);z-index:100000;color:#fff;'
  +   'font-size:14px;background:rgba(0,0,0,.45);padding:4px 12px;border-radius:99px}'
  + '@media(max-width:749px){.pvgz__nav{display:none}}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  function upsize(u){ u = u.replace(/^\/\//,'https://'); return /[?&]width=/.test(u) ? u.replace(/([?&])width=\d+/,'$1width=1600') : (u + (u.indexOf('?')>-1?'&':'?') + 'width=1600'); }
  function baseKey(u){ return (u||'').replace(/^https?:/,'').replace(/[?&]width=\d+/,'').replace(/[?&]v=\d+/,''); }

  function collect(fromEl){
    var panel = fromEl.closest('.pvg__panel') || fromEl.closest('.pvg') || document;
    var seen = {}, out = [];
    panel.querySelectorAll('img[src]').forEach(function(im){
      var s = im.getAttribute('src') || ''; if (!s) return;
      var k = baseKey(s); if (seen[k]) return; seen[k] = 1; out.push(upsize(s));
    });
    return out;
  }

  var lb, imgEl, stage, countEl, imgs = [], idx = 0;
  var scale = 1, tx = 0, ty = 0, natW = 0, natH = 0;

  function build(){
    if (lb) return;
    lb = document.createElement('div'); lb.className = 'pvgz'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true');
    lb.innerHTML =
        '<button class="pvgz__btn pvgz__close" aria-label="Close">&times;</button>'
      + '<button class="pvgz__btn pvgz__nav pvgz__prev" aria-label="Previous image">&#8249;</button>'
      + '<button class="pvgz__btn pvgz__nav pvgz__next" aria-label="Next image">&#8250;</button>'
      + '<div class="pvgz__stage"><img class="pvgz__img" alt=""></div>'
      + '<div class="pvgz__count"></div>';
    document.body.appendChild(lb);
    imgEl = lb.querySelector('.pvgz__img'); stage = lb.querySelector('.pvgz__stage'); countEl = lb.querySelector('.pvgz__count');
    lb.querySelector('.pvgz__close').addEventListener('click', close);
    lb.querySelector('.pvgz__prev').addEventListener('click', function(e){ e.stopPropagation(); go(-1); });
    lb.querySelector('.pvgz__next').addEventListener('click', function(e){ e.stopPropagation(); go(1); });
    lb.addEventListener('click', function(e){ if (e.target === lb || e.target === stage) close(); });
    document.addEventListener('keydown', function(e){
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1);
    });
    wireTouch();
  }

  function apply(){ imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
  function reset(){ scale = 1; tx = 0; ty = 0; apply(); }
  function render(){
    reset();
    imgEl.src = imgs[idx];
    countEl.textContent = (idx + 1) + ' / ' + imgs.length;
    countEl.style.display = imgs.length > 1 ? '' : 'none';
  }
  function go(d){ if (imgs.length < 2) return; idx = (idx + d + imgs.length) % imgs.length; render(); }
  function open(list, start){
    build(); imgs = list; idx = start || 0;
    lb.classList.add('is-open'); lb.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow = 'hidden'; render();
  }
  function close(){ lb.classList.remove('is-open'); lb.setAttribute('aria-hidden','true'); document.documentElement.style.overflow = ''; }

  function wireTouch(){
    var pts = {}, startDist = 0, startScale = 1, lastTap = 0, panStart = null, mid = {x:0,y:0};
    function count(){ return Object.keys(pts).length; }
    function dist(){ var k = Object.keys(pts); var a = pts[k[0]], b = pts[k[1]]; return Math.hypot(a.x-b.x, a.y-b.y); }
    function center(){ var k = Object.keys(pts); var a = pts[k[0]], b = pts[k[1]]; return {x:(a.x+b.x)/2, y:(a.y+b.y)/2}; }

    stage.addEventListener('pointerdown', function(e){
      stage.setPointerCapture(e.pointerId);
      pts[e.pointerId] = {x:e.clientX, y:e.clientY, sx:e.clientX, sy:e.clientY, t:Date.now()};
      if (count() === 2){ startDist = dist(); startScale = scale; mid = center(); }
      else if (scale > 1){ panStart = {x:e.clientX - tx, y:e.clientY - ty}; }
    });
    stage.addEventListener('pointermove', function(e){
      if (!pts[e.pointerId]) return;
      pts[e.pointerId].x = e.clientX; pts[e.pointerId].y = e.clientY;
      if (count() === 2){ // pinch
        var s = startScale * (dist() / startDist);
        scale = Math.max(1, Math.min(4, s)); apply();
      } else if (scale > 1 && panStart){ // pan
        tx = e.clientX - panStart.x; ty = e.clientY - panStart.y; apply();
      }
    });
    function end(e){
      var p = pts[e.pointerId]; delete pts[e.pointerId];
      if (!p) return;
      var dx = e.clientX - p.sx, dy = e.clientY - p.sy, dt = Date.now() - p.t;
      if (scale <= 1 && count() === 0 && Math.abs(dx) < 10 && Math.abs(dy) < 10 && dt < 300){
        var now = Date.now();
        if (now - lastTap < 300){ scale = 2.5; apply(); lastTap = 0; }  // double-tap zoom in
        else lastTap = now;
      } else if (scale <= 1 && count() === 0 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)){
        go(dx < 0 ? 1 : -1);  // swipe
      }
      if (scale <= 1){ tx = 0; ty = 0; apply(); }
      panStart = null;
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    // desktop double-click + wheel zoom
    imgEl.addEventListener('dblclick', function(e){ e.preventDefault(); scale = scale > 1 ? 1 : 2.5; reset(); if (scale > 1){ scale = 2.5; apply(); } });
    stage.addEventListener('wheel', function(e){ if (!lb.classList.contains('is-open')) return; e.preventDefault();
      scale = Math.max(1, Math.min(4, scale - (e.deltaY > 0 ? 0.2 : -0.2))); if (scale === 1){ tx = 0; ty = 0; } apply(); }, {passive:false});
  }

  // add a small zoom hint on the main image, and open on tap
  function addHints(){
    document.querySelectorAll('.pvg__main').forEach(function(m){
      if (m.querySelector('.pvg__zoomhint')) return;
      var h = document.createElement('div'); h.className = 'pvg__zoomhint';
      h.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="16" y1="16" x2="21" y2="21"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
      m.appendChild(h);
    });
  }
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest && e.target.closest('.pvg__main-img');
    if (!t) return;
    e.preventDefault();
    var list = collect(t); if (!list.length) return;
    var key = baseKey(t.getAttribute('src') || ''), start = 0;
    for (var i = 0; i < list.length; i++){ if (baseKey(list[i]) === key){ start = i; break; } }
    open(list, start);
  });
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(addHints);
  try { new MutationObserver(function(){ addHints(); }).observe(document.documentElement, {childList:true, subtree:true}); } catch (e) {}
})();
